import selectRawProduct from '../select-raw-product';
import type { RootState } from '../../reducers';

const selectProductsError = (state: RootState): RootState['product']['error'] | null =>
  selectRawProduct(state)?.error ?? null;

export default selectProductsError;
